// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selWidth[data-v-57d67a7f] {\r\n  width: 300px;\n}\n.color_red[data-v-57d67a7f] {\r\n  color: #f5222d;\n}\n.color_green[data-v-57d67a7f] {\r\n  color: #7abe5c;\n}\r\n", ""]);
// Exports
module.exports = exports;
